import Body from './Body';
import Heading from './Heading';
import Link from './Link';

export type { LinkProps, HeaderProps, ParagraphProps } from './interfaces';
export default {
  Heading,
  Body,
  Link
};
